var map = {
	"./add.svg": 4780,
	"./book-focus.svg": 9063,
	"./book.svg": 6004,
	"./bookmark-focus.svg": 6566,
	"./bookmark.svg": 8619,
	"./home-focus.svg": 339,
	"./home.svg": 2520,
	"./user-focus.svg": 8444,
	"./user.svg": 1816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;